"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _BaseForm = _interopRequireDefault(require("react-platform-components/dist/BaseComponents/BaseForm"));
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _formFields = require("react-platform-components/dist/form-fields");
var _formValidators = require("react-platform-components/dist/form-validators");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getFormExtraFields = function getFormExtraFields() {
  return [/*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "amount",
    label: "Montant",
    margin: "normal",
    variant: "outlined",
    type: "number",
    fullWidth: true,
    required: true,
    validate: (0, _formValidators.required)()
  })))];
};
var _default = (0, _BaseInjectors.injectToForm)(_BaseForm.default, {
  formExtraFields: function formExtraFields() {
    return getFormExtraFields();
  },
  handleInitialValues: function handleInitialValues() {
    return {
      'amount': ''
    };
  }
});
exports.default = _default;